import React from 'react'
import CampaignPage from '../index'
import { PageWrapper } from '../../../../Components/Campaigns/Page/PageWrapper'
import LogsContainer from './Container'

const Logs = props => {
  return (
    <CampaignPage
      active={props.nav}
      campaignId={props.match.params.campaignId}
      history={props.history}
      match={props.match}
      location={props.location}
    >
      <PageWrapper className="campaign-page-wrapper">
        <LogsContainer campaignId={props.match.params.campaignId} />
      </PageWrapper>
    </CampaignPage>
  )
}

export default Logs
